import * as State from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/State';
import { useHandler } from 'hooks/useHandler';

export default function useState() {
	const [state, rf] = useHandler<State.Type>(State.create());
	return {
		state,
		handlers: {
			changeErpRecipeName: rf.createReducer(State.changeErpRecipeName),
			createNewErpRecipe: rf.createReducerAsync(State.createNewErpRecipe),
			deleteErpRecipe: rf.createReducerAsync(State.deleteErpRecipe),
			initialize: rf.createReducerAsync(State.initialize),
			mapFirstSuggestionToProduct: rf.createReducer(State.mapFirstSuggestionToProduct),
			navigateBackToOverview: rf.createNoArgReducer(State.navigateBackToOverview),
			saveErpRecipe: rf.createReducerAsync(State.saveErpRecipe),
			setComparisonLeft: rf.createReducer(State.setComparisonLeft),
			setComparisonRight: rf.createReducer(State.setComparisonRight),
			setErpRecipeId: rf.createReducer(State.setErpRecipeId),
			setSearchTerm: rf.createReducer(State.setSearchTerm),
			setSelectedColumns: rf.createReducer(State.setSelectedColumns),
			setValueScope: rf.createReducer(State.setValueScope),
			toggleComparison: rf.createReducer(State.toggleComparison),
			toggleProductSelection: rf.createReducer(State.toggleProductSelection),
			searchAndAddNewProductsToIngredient: rf.createReducerAsync(
				State.searchAndAddNewProductsToIngredient
			),
			resetManuallySearchedProductsFromIngredient: rf.createReducer(
				State.resetManuallySearchedProductsFromIngredient
			),
		},
	};
}

export type RecipeErpViewHandlers = ReturnType<typeof useState>['handlers'];
